/* eslint-disable */
import React from 'react';
import { StoreStateContext } from '../../context/store/StoreProvider';
import TemplateMX from './TemplateMX';
import Template from './Template';
import { FieldSheet, FieldSheetSection6Retention } from '../../types/types';

export interface FieldSheetLetterProps {
  fieldSheets?: FieldSheet[];
  retentionOffers: FieldSheetSection6Retention[];
  classes?: any;
  carInstructions?: string;
}       

class ComponentToPrint extends React.Component<FieldSheetLetterProps> {
  static contextType = StoreStateContext;

  render() {
    const { fieldSheets = [], retentionOffers, carInstructions } = this.props;
    const { isMXAccountManagement } = this.context;

   

    if (!fieldSheets.length) {
      return <div>No field sheets to display.</div>;
    }

    return (
      <div>
        {isMXAccountManagement
          ? fieldSheets.map((sheet: FieldSheet, index: number) => (
              <TemplateMX
                key={index}
                fieldSheet={sheet}
                totalFieldSheets={fieldSheets.length}
                fieldSheeNum={index}
                carInstructions={carInstructions}
              />
            ))
          : fieldSheets.map((sheet: FieldSheet, index: number) => (
              <Template
                key={index}
                fieldSheet={sheet}
                totalFieldSheets={fieldSheets.length}
                fieldSheeNum={index}
                carInstructions={carInstructions}
              />
            ))}
      </div>
    );
  }
}

export default ComponentToPrint;